import { render, staticRenderFns } from "./SelectedProductModal.html?vue&type=template&id=5c70e20d&scoped=true&"
import script from "./SelectedProductModal.js?vue&type=script&lang=js&"
export * from "./SelectedProductModal.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5c70e20d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70e20d",
  null
  
)

export default component.exports